import { ICON_COLORS } from "./avatar-picker.constants";

export const IconColorsGrid = () => {
  return (
    <span className="flex size-4 flex-wrap items-center justify-center gap-px">
      {ICON_COLORS.slice(0, 9).map((color) => (
        <span
          key={color}
          className="size-1 rounded-[1px]"
          style={{ background: color }}
        />
      ))}
    </span>
  );
};
